module.exports = __webpack_public_path__ + "img/sponsor-06.018d430c.png";